module.exports = "/images/qizhi_6ea894.png";